<div class="layout-breadcrumb">
    <ul>
        <li><a routerLink=""><i class="material-icons">home</i></a></li>
        <li><i class="material-icons">chevron_right</i></li>
        <ng-template ngFor let-item let-last="last" [ngForOf]="items">
            <li>
                <a [routerLink]="item.routerLink" *ngIf="item.routerLink">{{item.label}}</a>
                <ng-container *ngIf="!item.routerLink">{{item.label}}</ng-container>
            </li>
            <li *ngIf="!last"><i class="material-icons">chevron_right</i></li>
        </ng-template>
    </ul>
</div>
